"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterIcon = exports.TextFormatterNames = void 0;
var tslib_1 = require("tslib");
var FormattingTextBoldIcon_1 = require("@tableau/icons/FormattingTextBoldIcon");
var FormattingTextH1Icon_1 = require("@tableau/icons/FormattingTextH1Icon");
var FormattingTextH2Icon_1 = require("@tableau/icons/FormattingTextH2Icon");
var FormattingTextH3Icon_1 = require("@tableau/icons/FormattingTextH3Icon");
var FormattingTextItalicIcon_1 = require("@tableau/icons/FormattingTextItalicIcon");
var FormattingTextParagraphIcon_1 = require("@tableau/icons/FormattingTextParagraphIcon");
var FormattingTextUnderlineIcon_1 = require("@tableau/icons/FormattingTextUnderlineIcon");
var LinkDiagonalIcon_1 = require("@tableau/icons/LinkDiagonalIcon");
var TextListOrderedIcon_1 = require("@tableau/icons/TextListOrderedIcon");
var TextListUnorderedIcon_1 = require("@tableau/icons/TextListUnorderedIcon");
var React = tslib_1.__importStar(require("react"));
var Localize_1 = require("../../gen-src/Localize");
var IconMap = {
    Bold: FormattingTextBoldIcon_1.FormattingTextBoldIcon,
    Heading1: FormattingTextH1Icon_1.FormattingTextH1Icon,
    Heading2: FormattingTextH2Icon_1.FormattingTextH2Icon,
    Heading3: FormattingTextH3Icon_1.FormattingTextH3Icon,
    Italic: FormattingTextItalicIcon_1.FormattingTextItalicIcon,
    Link: LinkDiagonalIcon_1.LinkDiagonalIcon,
    OrderedList: TextListOrderedIcon_1.TextListOrderedIcon,
    Paragraph: FormattingTextParagraphIcon_1.FormattingTextParagraphIcon,
    Underline: FormattingTextUnderlineIcon_1.FormattingTextUnderlineIcon,
    UnorderedList: TextListUnorderedIcon_1.TextListUnorderedIcon,
};
exports.TextFormatterNames = {
    Bold: function () { return Localize_1.Messages.bold(); },
    Heading1: function () { return Localize_1.Messages.heading1(); },
    Heading2: function () { return Localize_1.Messages.heading2(); },
    Heading3: function () { return Localize_1.Messages.heading3(); },
    Italic: function () { return Localize_1.Messages.italics(); },
    Link: function () { return Localize_1.Messages.link(); },
    OrderedList: function () { return Localize_1.Messages.orderedList(); },
    Paragraph: function () { return Localize_1.Messages.paragraph(); },
    Underline: function () { return Localize_1.Messages.underline(); },
    UnorderedList: function () { return Localize_1.Messages.unorderedList(); },
};
var TextFormatterIcon = function (_a) {
    var type = _a.type, elemAttrs = tslib_1.__rest(_a, ["type"]);
    return React.createElement(IconMap[type], tslib_1.__assign({ alt: exports.TextFormatterNames[type](), key: type + "_textileIcon", size: 14 }, elemAttrs));
};
exports.TextFormatterIcon = TextFormatterIcon;
//# sourceMappingURL=TextFormatterIcons.js.map